<div fxLayoutAlign="space-between center" style="margin-bottom: 40px">
  <h2 class="nomargin">Widget preview</h2>
  <sbnb-close [border]="true" (click)="dialogRef.close()"></sbnb-close>
</div>

<div fxLayout="column">
  <strong>Property</strong>
  <mat-form-field>
    <mat-select [(ngModel)]="dialogData.propertyId" (ngModelChange)="rebuildWidgetUrl()">
      <mat-option *ngFor="let property of dialogData.properties" [value]="property.id">
        {{ property.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayoutAlign="center center">
  <iframe
    sandbox="allow-scripts allow-same-origin"
    style="width: 320px; height: 800px"
    frameborder="0"
    [src]="widgetUrl"></iframe>
</div>
